import { render } from "./PartnerCarVerify.vue?vue&type=template&id=64a1e234&ts=true"
import script from "./PartnerCarVerify.vue?vue&type=script&lang=ts"
export * from "./PartnerCarVerify.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__